import * as React from "react";
import { PromoteInstallmentsLabel } from "@grandvisionhq/content";
import { useIntl } from "@grandvisionhq/state";
import { formatPrice } from "@grandvisionhq/utils";
import { PromoteInstallmentsModalSlot } from "../../../../PromoteInstallmentsModalSlot/modules/EcommContent/components/PromoteInstallments/PromoteInstallmentsModalSlot/PromoteInstallmentsModalSlot.js";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
const getExcludedProductType = (enabledProductTypes, productType) => {
  if (!enabledProductTypes || !productType) {
    return false;
  }
  return !enabledProductTypes.some((product) => product.toLowerCase() === productType.toLowerCase());
};
const PromoteInstallments = ({
  siteLogos,
  numberOfInstallments,
  minimumPrice,
  productType,
  enabledProductTypes,
  textAlign
}) => {
  const { currency, locale } = useIntl();
  const { displayPrice } = useProductData();
  const priceAmount = displayPrice.discountedPrice || displayPrice.originalPrice;
  const excludedProductType = getExcludedProductType(enabledProductTypes, productType);
  const isCentAmount = false;
  const installmentPrice = formatPrice({
    locale,
    value: priceAmount / numberOfInstallments,
    currency,
    isCentAmount
  });
  if (priceAmount < minimumPrice || excludedProductType) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    PromoteInstallmentsLabel,
    {
      installmentPrice,
      numberOfInstallments,
      textAlign,
      modalBodySlot: /* @__PURE__ */ React.createElement(
        PromoteInstallmentsModalSlot,
        {
          siteLogos,
          price: priceAmount,
          isCentAmount,
          numberOfInstallments
        }
      )
    }
  );
};
export {
  PromoteInstallments
};
//# sourceMappingURL=PromoteInstallments.js.map
